<!-- 再来人辅导项目 -->
<template>
  <div class="project-coach">
    <div class="project-coach-item project-coach-have">
      <div class="project-coach-item-top">
        <span>再来人辅导项目</span>
        <img :src="setBlack"
             alt=""
             @click="setHandle">
      </div>
      <ul class="project-coach-have-con animated animatedFadeIn"
          v-if="materialList.length>0">
        <li v-for="(item,index) in materialList"
            :key="index">
          <zlr-card-service :title="item.project.univer"
                            style="width: 400px;"
                            kind="ETH"
                            :bgText="item.project.univer.replace(/\s/g,'').substr(0,3).toUpperCase()"
                            :explainList="item.backLogs|backLogsFilters"
                            circle="waiting"
                            @click="linkRecordHandle(item)"
                            :dotted=true
                            :dottedList="item.progress.bills | dottedfilter">
            <div>{{item.project.overseasName}}</div>
            <div>Application DDL:{{item.project.deadlineTime}}</div>
          </zlr-card-service>
        </li>
      </ul>
      <zlr-empty v-else
                 style="margin-bottom:40px;"></zlr-empty>
    </div>
    <div class="project-coach-item project-coach-no">
      <div class="project-coach-item-top project-coach-no-top">
        <span>非辅导项目</span>
      </div>
      <ul class="project-coach-no-con animated animatedFadeIn"
          v-if="unZlrList.length>0">
        <li v-for="(item, index) in unZlrList"
            :key="index">
          <div class="project-coach-no-item">
            <div>
              <h1>
                {{item.univer}}
              </h1>
              <h1>
                {{item.location}}
              </h1>
            </div>
            <div>
              <span> {{item.overseasName}}</span>
              <span>DDL: {{item.rolling === 1?'rolling':item.deadlineTime}}</span>
            </div>
          </div>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <!-- 设置 -->
    <coach-set ref="coachset"
               :isSet="isSet"
               @on-success="isSet = true"></coach-set>
  </div>
</template>

<script>
// API
import { getMaterialProject } from '@/api/material'
import { getProjectUnZlrList } from '@/api/project'
// images
import setBlack from '@/assets/images/home/setting-black.svg'
// components
import ZlrCardService from '_c/card-service/card-service'
import CoachSet from './components/coach-set'
import ZlrEmpty from '_c/empty/empty'
export default {
  name: 'project-coach',
  components: {
    ZlrCardService,
    CoachSet,
    ZlrEmpty
  },
  data () {
    return {
      setBlack,
      materialList: [],
      unZlrList: [],
      isSet: false
    }
  },
  computed: {},
  mounted () {
    this.getMaterialProject()
    this.getProjectUnZlrList()
  },
  methods: {
    // 获取再来人辅导列表
    getMaterialProject () {
      getMaterialProject().then((res) => {
        this.materialList = res.data.model.projects
      })
    },
    // 获取非再来人辅导项目
    getProjectUnZlrList () {
      getProjectUnZlrList({
        'active': true
      }).then((res) => {
        this.unZlrList = res.data.model
      })
    },
    // 设置
    setHandle () {
      this.$refs['coachset'].showHandle()
    },
    linkRecordHandle (item) {
      let id = item.project.id
      this.$router.push({
        name: 'project-essay-info',
        params: {
          id
        }
      })
    }
  },
  filters: {
    backLogsFilters (logs) {
      if (logs.length === 0) return []
      let arr = []
      logs.forEach(item => {
        arr.push({ title: item.content, color: '#85A5FF' })
      })
      return arr
    },
    dottedfilter (dotted) {
      if (dotted.length === 0) return []
      let arr = []
      dotted.forEach(item => {
        let emEdit = item.emEdit || []
        let smEdit = item.smEdit || []
        let emEditActvie = emEdit.filter(item => item.status === 'EDITED').length
        let smEditActvie = smEdit.filter(item => item.status === 'EDITED').length
        arr.push({
          conNum: emEdit.length + smEdit.length,
          activeNum: emEditActvie + smEditActvie
        })
      })
      return arr
    }
  }
}
</script>
<style lang='less' scoped>
</style>
